var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgNotConnectedYet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1426,
    viewBox: "0 0 1920 1426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2787_1405)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1426,
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2787_1405)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 969.5,
    cy: 77,
    rx: 704.5,
    ry: 226,
    fill: "url(#paint0_linear_2787_1405)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2787_1405)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2787_1405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1608.86 1065.7C2238.5 721.41 1877.77 1180.62 1925 1395.91C1693 1499.44 996.561 1561.31 884.553 1550.31C742.925 1407.73 818.411 1501.28 884.554 1487.79C1039.61 1456.15 1069.7 1094.94 1237.5 1111.41C1393.07 1126.68 1508.34 1162.66 1608.86 1065.7Z",
    fill: "url(#paint1_linear_2787_1405)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2787_1405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.891 1088.09C-127.502 1281.78 -293.388 1197.45 1.95754 1533.62C216.954 1668.96 201.361 1415.71 313.797 1420.69C474.195 1299.61 912.208 1601.7 848.644 1578.98C699.632 1525.69 1095.05 1113.95 926.606 1106.49C828.567 1088.43 577.916 952.935 336.891 1088.09Z",
    fill: "url(#paint2_linear_2787_1405)",
    fillOpacity: 0.8
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2787_1405",
    x: 45,
    y: -369,
    width: 1849,
    height: 892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 110,
    result: "effect1_foregroundBlur_2787_1405"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2787_1405",
    x: 624.217,
    y: 761.682,
    width: 1541.43,
    height: 969.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_2787_1405"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2787_1405",
    x: -345.736,
    y: 828.754,
    width: 1514.96,
    height: 951.449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_2787_1405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2787_1405",
    x1: 1674,
    y1: 75.3741,
    x2: 265,
    y2: 75.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528846,
    stopColor: "#0022FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2787_1405",
    x1: 830.336,
    y1: 1446.22,
    x2: 1813.02,
    y2: 898.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2787_1405",
    x1: 939.271,
    y1: 1645.31,
    x2: 290.936,
    y2: 706.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750625,
    stopColor: "#A660FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2787_1405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1426,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2787_1405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 589,
    fill: "white",
    transform: "translate(0 837.91)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnectedYet);
export default __webpack_public_path__ + "static/media/not-connected-yet.e22ff1f15854112c76039d5e1a0d3380.svg";
export { ForwardRef as ReactComponent };